import React from 'react';
import { connect } from 'react-redux';
import './TimeoutPopup.scss';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import Analytics from '../../helpers/analytics/analytics';
import dataModel from '../../models/DataModel';
import SessionManager from '../../helpers/session/SessionManager';
import Metadata from '../../helpers/metadata/Metadata';
import connectivityHeartbeat from '../../helpers/ConnectivityHeartbeat';
import unreadAnnouncements from '../../helpers/Announcements/UnreadAnnouncements';

export class TimeoutPopup extends BaseComponent {
  constructor(props) {
    super(props);

    this.timePeriod = parseInt(process.env.REACT_APP_SESSION_TIMEOUT_KEY ? process.env.REACT_APP_SESSION_TIMEOUT_KEY : 60, 10) * 2;
    if (this.timePeriod > 120) {
      this.timePeriod = 120;
    }
    this.state = { countDown: this.timePeriod };

    this.timerInterval = setInterval(this.handleTimer, 1000);
    this.lastTime = new Date();
    let opts = {};
    opts.currentRole = props.currentUser ? props.currentUser.role : null;
    this.analytics = new Analytics(opts);

  }

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  handleTimer() {
    let currentTime = new Date();
    let timeLeft = Math.round(this.timePeriod - ((currentTime - this.lastTime) / 1000));
    // if (this.clock) {
    //   let timeLeftSeconds = timeLeft % 60
    //   this.clock.style.transform = "rotate(" + timeLeftSeconds * -6 + "deg)"
    // }

    if (timeLeft > 0) {
      this.setState({ countDown: timeLeft });
    }
    else {
      clearInterval(this.timerInterval);
      Metadata.stop();
      connectivityHeartbeat.stop();
      unreadAnnouncements.stop();
      this.props.dataModel.sessionTimeout = false;
      this.props.dataModel.needsPartialLogin = true;
    }
  }

  handleLogout() {
    clearInterval(this.timerInterval);
    this.props.dataModel.sessionTimeout = false;
    this.props.dataModel.setPassthroughUri(null);
    SessionManager.logoff(true);
    this.analytics.event('Session Management', 'Click', 'SessionManagementLogout');
  }

  handleContinue() {
    this.props.dataModel.sessionTimeout = false;
    SessionManager.reissueToken().then((token) => {
    });
    this.analytics.event('Session Management', 'Click', 'SessionManagementReset');
  }

  render() {
    const countDownMins = Math.floor(this.state.countDown / 60);
    const countDownSecs = this.state.countDown % 60;
    let brandColor = '#CD030A';
    if (this.props.company && this.props.company.accent_color) {
      brandColor = this.props.company.accent_color;
    }

    const countDown = countDownMins + (countDownMins > 1 ? ' mins ' : ' min ') + countDownSecs + (countDownSecs > 1 ? ' secs' : ' sec');
    const popUp = (
      <div className='timeout-modal-overlay' id='timeout-modal-overlay'>
        <div className='timeout-modal' id='modal'>
          <div className='timeout-modal-header' style={{ backgroundColor: brandColor }}>
            <div> Session Timeout </div>
          </div>
          <div className='timeout-modal-body'>
            <div className='clock-icon' ref={(element) => { this.clock = element; }}>
            </div>
            <div className='title-text'>
              <div className='text'>
                Your session will expire in
              </div>
            </div>
            <div className='clock-text'>{countDown}</div>
            <div>Please click "Continue" to keep working.</div>
          </div>
          <div className='timeout-modal-footer'>
            <div className='footer-left'>
              <div className='timeout-modal-button' id='continue-button' style={{ backgroundColor: brandColor }}
                onClick={this.handleContinue}>
                <div className='text'>Continue</div>
              </div>
            </div>
            <div className='footer-right'>
              <div className='timeout-modal-button' style={{ border: '1px solid ' + brandColor }} id='logout-button' onClick={this.handleLogout}>
                <div className='text' style={{ color: brandColor }}>Logout</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    return popUp;
  }
}

const mapStateToProps = (state, ownProps) => {
  let company = state.new_companies.currentCompany;
  if (state.new_companies['company_' + company.id]) {
    company = state.new_companies['company_' + company.id].company;
  }
  return {
    dataModel: dataModel,
    company: company,
    currentUser: state.new_users.currentUser,
    
  };
};

export default connect(mapStateToProps)(TimeoutPopup);



// WEBPACK FOOTER //
// ./src/components/TimeoutPopup/index.js